// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comments-section {
  max-width: 750px;
  margin: 60px auto 40px;
  padding: 0 20px;
}

.comments-toggle-bar {
  text-align: center;
  padding: 40px 20px;
  background: var(--bg-secondary);
  border: 2px solid var(--border-color);
  border-radius: 12px;
  margin: 40px 0;
}

.comments-toggle-btn {
  padding: 12px 24px;
  background: var(--accent-primary);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.comments-toggle-btn:hover {
  opacity: 0.9;
  transform: translateY(-2px);
}

.comments-header {
  display: flex;
  align-items: flex-start;
  margin-bottom: 32px;
  padding-bottom: 20px;
  border-bottom: 2px solid var(--border-color);
  justify-content: space-between;
}

.comments-title-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap:12px;
}

.comments-title {
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0;
  color: var(--text-primary);
}

.comments-close-btn {
  padding: 8px 16px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  font-weight: 600;
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 3px;
}

.comments-close-btn:hover {
  border-color: var(--accent-primary);
  background: var(--bg-hover);
}

/* Comments controls */
.comments-controls {
  display: flex;
  align-items: center;
  gap: 12px;
}

.sort-label {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-secondary);
}

.sort-select {
  padding: 8px 12px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  color: var(--text-primary);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.sort-select:hover,
.sort-select:focus {
  border-color: var(--accent-primary);
  outline: none;
}

/* Article Reply Box */
.article-reply-box {
  margin: 32px 0;
  padding: 24px;
  background: var(--bg-secondary);
  border: 2px solid var(--border-color);
  border-radius: 12px;
  transition: border-color 0.3s;
}

.article-reply-box:focus-within {
  border-color: var(--accent-primary);
}

.reply-textarea {
  width: 100%;
  min-height: 120px;
  padding: 16px;
  background: var(--bg-tertiary);
  border: 2px solid var(--border-color);
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 1rem;
  font-family: inherit;
  resize: vertical;
  transition: all 0.2s;
  margin-bottom: 12px;
}

.reply-textarea:focus {
  outline: none;
  border-color: var(--accent-primary);
  background: var(--bg-primary);
}

.reply-textarea::placeholder {
  color: var(--text-tertiary);
}

.reply-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.reply-meta-actions, .reply-submit-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.reply-submit-btn {
  padding: 12px 24px;
  background: var(--accent-primary);
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s;
}

.reply-submit-btn:hover {
  opacity: 0.9;
  transform: translateY(-2px);
}

.reply-submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.reply-cancel-btn {
  padding: 12px 24px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  font-weight: 600;
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s;
}

.reply-cancel-btn:hover {
  border-color: var(--danger-color);
  background: var(--hover-bg);
}

.reply-cancel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  border-color: var(--border-color);
  background: var(--bg-secondary);
}

/* Empty state */
.empty-comments {
  text-align: center;
  padding: 60px 20px;
  background: var(--bg-secondary);
  border: 2px dashed var(--border-color);
  border-radius: 12px;
  margin: 20px 0;
}

.empty-comments p {
  font-size: 1rem;
  color: var(--text-secondary);
  margin: 0;
}

/* Comments list */
.comments-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: unset;
  justify-content: unset;
}

/* Comment nesting */
.comment-node {
  position: relative;
  margin-left: 0;
}

.comment-node::before {
  content: '';
  position: absolute;
  left: -12px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: var(--border-color);
  opacity: 0.6;
  transition: all 0.2s;
}

.comment-node:hover::before {
  background: var(--accent-primary);
  opacity: 1;
}

.nested-replies {
  margin-top: 8px;
  margin-left: 0;
  border-left: none;
  padding-left: 8px;
}

/* Level-specific styling */
.nested-replies .comment-node.level-1,
.nested-replies .comment-node.level-2,
.nested-replies .comment-node.level-3,
.nested-replies .comment-node.level {
  margin-left: 12px;
}

.nested-replies .view-deeper-container {
  margin-top:-25px;
  margin-bottom:25px;
  margin-left:18px;
}

/* Loading state */
.comments-list.loading-state[data-state="loading"] {
  opacity: 0.7;
  pointer-events: none;
}

/* Placeholder skeleton for comments-count present but comments not yet loaded */
.comments-section .comments-placeholder {
  padding: 20px;
  background: var(--bg-secondary);
  border: 2px solid var(--border-color);
  border-radius: 12px;
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.comments-section .comment-skeleton {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.comments-section .skeleton-avatar {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: linear-gradient(90deg, var(--bg-tertiary), rgba(255,255,255,0.02));
  animation: skeleton-pulse 1.4s infinite ease-in-out;
  flex-shrink: 0;
}

.comments-section .skeleton-avatar.small {
  width: 36px;
  height: 36px;
}

.comments-section .skeleton-lines {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.comments-section .skeleton-line {
  height: 12px;
  background: var(--bg-tertiary);
  border-radius: 8px;
  width: 100%;
  opacity: 0.8;
}

.comments-section .skeleton-line.short {
  width: 60%;
}

.comments-section .skeleton-line.tiny {
  width: 30%;
  height: 10px;
}

.comments-section .loading-note {
  text-align: center;
  color: var(--text-secondary);
  font-size: 0.95rem;
  margin-top: 6px;
}

@keyframes skeleton-pulse {
  0% { opacity: 1; }
  50% { opacity: 0.45; }
  100% { opacity: 1; }
}

/* Mobile responsive */
@media (max-width: 768px) {
  .comments-section {
    margin: 40px auto 20px;
    padding: 0 16px;
  }

  .comments-title {
    font-size: 1.4rem;
  }

  .comments-title-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .comments-close-btn {
    align-self: flex-start;
  }

  .comments-controls {
    flex-wrap: wrap;
  }

  .nested-replies {
    margin-left: 8px;
    padding-left: 4px;
  }

  .comment-node.level-1,
  .comment-node.level-2,
  .comment-node.level-3,
  .comment-node.level {
    margin-left: 0;
  }

  .comment-node::before,
  .comment-node.level-1::before,
  .comment-node.level-2::before,
  .comment-node.level-3::before,
  .comment-node.level::before {
    left: -8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CommentsSection/CommentsSection.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;EAC5C,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,mCAAmC;EACnC,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,aAAa;EACb,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,SAAS;EACT,UAAU;EACV,+BAA+B;EAC/B,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8EAA8E;EAC9E,mDAAmD;EACnD,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,aAAa,EAAE;EACrB,OAAO,UAAU,EAAE;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;;;IAIE,cAAc;EAChB;;EAEA;;;;;IAKE,UAAU;EACZ;AACF","sourcesContent":[".comments-section {\r\n  max-width: 750px;\r\n  margin: 60px auto 40px;\r\n  padding: 0 20px;\r\n}\r\n\r\n.comments-toggle-bar {\r\n  text-align: center;\r\n  padding: 40px 20px;\r\n  background: var(--bg-secondary);\r\n  border: 2px solid var(--border-color);\r\n  border-radius: 12px;\r\n  margin: 40px 0;\r\n}\r\n\r\n.comments-toggle-btn {\r\n  padding: 12px 24px;\r\n  background: var(--accent-primary);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.comments-toggle-btn:hover {\r\n  opacity: 0.9;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.comments-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  margin-bottom: 32px;\r\n  padding-bottom: 20px;\r\n  border-bottom: 2px solid var(--border-color);\r\n  justify-content: space-between;\r\n}\r\n\r\n.comments-title-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap:12px;\r\n}\r\n\r\n.comments-title {\r\n  font-size: 1.8rem;\r\n  font-weight: 700;\r\n  margin: 0;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.comments-close-btn {\r\n  padding: 8px 16px;\r\n  background: var(--bg-tertiary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 6px;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  margin-top: 3px;\r\n}\r\n\r\n.comments-close-btn:hover {\r\n  border-color: var(--accent-primary);\r\n  background: var(--bg-hover);\r\n}\r\n\r\n/* Comments controls */\r\n.comments-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.sort-label {\r\n  font-size: 0.95rem;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.sort-select {\r\n  padding: 8px 12px;\r\n  background: var(--bg-tertiary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 6px;\r\n  color: var(--text-primary);\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.sort-select:hover,\r\n.sort-select:focus {\r\n  border-color: var(--accent-primary);\r\n  outline: none;\r\n}\r\n\r\n/* Article Reply Box */\r\n.article-reply-box {\r\n  margin: 32px 0;\r\n  padding: 24px;\r\n  background: var(--bg-secondary);\r\n  border: 2px solid var(--border-color);\r\n  border-radius: 12px;\r\n  transition: border-color 0.3s;\r\n}\r\n\r\n.article-reply-box:focus-within {\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.reply-textarea {\r\n  width: 100%;\r\n  min-height: 120px;\r\n  padding: 16px;\r\n  background: var(--bg-tertiary);\r\n  border: 2px solid var(--border-color);\r\n  border-radius: 8px;\r\n  color: var(--text-primary);\r\n  font-size: 1rem;\r\n  font-family: inherit;\r\n  resize: vertical;\r\n  transition: all 0.2s;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.reply-textarea:focus {\r\n  outline: none;\r\n  border-color: var(--accent-primary);\r\n  background: var(--bg-primary);\r\n}\r\n\r\n.reply-textarea::placeholder {\r\n  color: var(--text-tertiary);\r\n}\r\n\r\n.reply-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n}\r\n\r\n.reply-meta-actions, .reply-submit-actions {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.reply-submit-btn {\r\n  padding: 12px 24px;\r\n  background: var(--accent-primary);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.reply-submit-btn:hover {\r\n  opacity: 0.9;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.reply-submit-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n  transform: none;\r\n}\r\n\r\n.reply-cancel-btn {\r\n  padding: 12px 24px;\r\n  background: var(--bg-tertiary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 6px;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.reply-cancel-btn:hover {\r\n  border-color: var(--danger-color);\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.reply-cancel-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n  border-color: var(--border-color);\r\n  background: var(--bg-secondary);\r\n}\r\n\r\n/* Empty state */\r\n.empty-comments {\r\n  text-align: center;\r\n  padding: 60px 20px;\r\n  background: var(--bg-secondary);\r\n  border: 2px dashed var(--border-color);\r\n  border-radius: 12px;\r\n  margin: 20px 0;\r\n}\r\n\r\n.empty-comments p {\r\n  font-size: 1rem;\r\n  color: var(--text-secondary);\r\n  margin: 0;\r\n}\r\n\r\n/* Comments list */\r\n.comments-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  align-items: unset;\r\n  justify-content: unset;\r\n}\r\n\r\n/* Comment nesting */\r\n.comment-node {\r\n  position: relative;\r\n  margin-left: 0;\r\n}\r\n\r\n.comment-node::before {\r\n  content: '';\r\n  position: absolute;\r\n  left: -12px;\r\n  top: 0;\r\n  bottom: 0;\r\n  width: 2px;\r\n  background: var(--border-color);\r\n  opacity: 0.6;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.comment-node:hover::before {\r\n  background: var(--accent-primary);\r\n  opacity: 1;\r\n}\r\n\r\n.nested-replies {\r\n  margin-top: 8px;\r\n  margin-left: 0;\r\n  border-left: none;\r\n  padding-left: 8px;\r\n}\r\n\r\n/* Level-specific styling */\r\n.nested-replies .comment-node.level-1,\r\n.nested-replies .comment-node.level-2,\r\n.nested-replies .comment-node.level-3,\r\n.nested-replies .comment-node.level {\r\n  margin-left: 12px;\r\n}\r\n\r\n.nested-replies .view-deeper-container {\r\n  margin-top:-25px;\r\n  margin-bottom:25px;\r\n  margin-left:18px;\r\n}\r\n\r\n/* Loading state */\r\n.comments-list.loading-state[data-state=\"loading\"] {\r\n  opacity: 0.7;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Placeholder skeleton for comments-count present but comments not yet loaded */\r\n.comments-section .comments-placeholder {\r\n  padding: 20px;\r\n  background: var(--bg-secondary);\r\n  border: 2px solid var(--border-color);\r\n  border-radius: 12px;\r\n  margin: 20px 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.comments-section .comment-skeleton {\r\n  display: flex;\r\n  gap: 12px;\r\n  align-items: flex-start;\r\n}\r\n\r\n.comments-section .skeleton-avatar {\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: 8px;\r\n  background: linear-gradient(90deg, var(--bg-tertiary), rgba(255,255,255,0.02));\r\n  animation: skeleton-pulse 1.4s infinite ease-in-out;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.comments-section .skeleton-avatar.small {\r\n  width: 36px;\r\n  height: 36px;\r\n}\r\n\r\n.comments-section .skeleton-lines {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.comments-section .skeleton-line {\r\n  height: 12px;\r\n  background: var(--bg-tertiary);\r\n  border-radius: 8px;\r\n  width: 100%;\r\n  opacity: 0.8;\r\n}\r\n\r\n.comments-section .skeleton-line.short {\r\n  width: 60%;\r\n}\r\n\r\n.comments-section .skeleton-line.tiny {\r\n  width: 30%;\r\n  height: 10px;\r\n}\r\n\r\n.comments-section .loading-note {\r\n  text-align: center;\r\n  color: var(--text-secondary);\r\n  font-size: 0.95rem;\r\n  margin-top: 6px;\r\n}\r\n\r\n@keyframes skeleton-pulse {\r\n  0% { opacity: 1; }\r\n  50% { opacity: 0.45; }\r\n  100% { opacity: 1; }\r\n}\r\n\r\n/* Mobile responsive */\r\n@media (max-width: 768px) {\r\n  .comments-section {\r\n    margin: 40px auto 20px;\r\n    padding: 0 16px;\r\n  }\r\n\r\n  .comments-title {\r\n    font-size: 1.4rem;\r\n  }\r\n\r\n  .comments-title-row {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 12px;\r\n  }\r\n\r\n  .comments-close-btn {\r\n    align-self: flex-start;\r\n  }\r\n\r\n  .comments-controls {\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  .nested-replies {\r\n    margin-left: 8px;\r\n    padding-left: 4px;\r\n  }\r\n\r\n  .comment-node.level-1,\r\n  .comment-node.level-2,\r\n  .comment-node.level-3,\r\n  .comment-node.level {\r\n    margin-left: 0;\r\n  }\r\n\r\n  .comment-node::before,\r\n  .comment-node.level-1::before,\r\n  .comment-node.level-2::before,\r\n  .comment-node.level-3::before,\r\n  .comment-node.level::before {\r\n    left: -8px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
